import { TestsOverview } from "../../../components/templates/TestsOverview.js";
import { MapPreviewCard } from "../../../components/organisms/MapPreviewCard.js";
import { useChapterContext } from "./useChapterContext.js";
import { Card, Grid } from "@mmm/ui";
export function ChapterOverviewTab() {
  const { subject, chapter } = useChapterContext();
  return <>
    <Grid minItemWidth={420} gap={18} className="mmm-chapter-overview-grid">
      <Card padding="md" className="mmm-chapter-overview-summary">
        <div><h2>{chapter.title}</h2><p>{subject.title}</p></div>
      </Card>
      <MapPreviewCard
        title={chapter.title}
        color={subject.color}
        mindMapId={subject.mindMaps.find((map) => map.chapterId === chapter.id)?.id}
        to={`/subjects/${subject.id}/chapters/${chapter.id}/map`}
      />
    </Grid>
    <TestsOverview subjectId={subject.id} tests={subject.aiTests.filter((test) => test.chapterIds?.includes(chapter.id) ?? test.chapterId === chapter.id)} />
  </>;
}
